import { DEFAULT_LANG } from '@cpak/consts';
import { environment } from '../../environments/environment';

export const TRANSLATION_CONFIG = {
  availableLangs: [DEFAULT_LANG],
  defaultLang: DEFAULT_LANG,
  prodMode: environment.production,
  reRenderOnLangChange: true,
};
